import type { ReactNode } from 'react';
import './coachmark.css';

export interface CoachmarkProps {
  open: boolean;
  title: string;
  body: ReactNode;
  actionLabel?: string;
  onDismiss: () => void;
  /** De qué lado nace el caret que apunta al elemento anclado. Default: 'right' */
  align?: 'left' | 'right';
}

/**
 * Mensaje contextual de una sola vez, anclado a un elemento puntual (ej. el botón de ayuda).
 * El contenedor padre debe tener position: relative.
 */
export function Coachmark({ open, title, body, actionLabel = 'Entendido', onDismiss, align = 'right' }: CoachmarkProps) {
  if (!open) return null;

  return (
    <div className={`coachmark coachmark--${align}`} role="dialog" aria-live="polite">
      <p className="coachmark-title">{title}</p>
      <p className="coachmark-body">{body}</p>
      <button type="button" className="coachmark-btn" onClick={onDismiss}>
        {actionLabel}
      </button>
    </div>
  );
}
